import { render } from "./TrainingParticipant.vue?vue&type=template&id=63afe51c&scoped=true"
import script from "./TrainingParticipant.vue?vue&type=script&lang=js"
export * from "./TrainingParticipant.vue?vue&type=script&lang=js"

import "./TrainingParticipant.vue?vue&type=style&index=0&id=63afe51c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63afe51c"

export default script